"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.selectionModes = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = require("react-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _moment = _interopRequireDefault(require("moment"));

var _CwContextMenu = _interopRequireDefault(require("../cwcontextmenu/CwContextMenu"));

var _CwLoader = _interopRequireDefault(require("../cwloader/CwLoader"));

var _DateFilterDialog = _interopRequireDefault(require("./components/Dialogs/DateFilterDialog"));

var _ColumnHeaderContainer = _interopRequireDefault(require("./components/ColumnHeaderContainer"));

var _CellCustom = _interopRequireDefault(require("./cellTypes/CellCustom"));

var _CellBoolFlags = _interopRequireDefault(require("./cellTypes/CellBoolFlags"));

var _CellDate = _interopRequireDefault(require("./cellTypes/CellDate"));

var _CellFlags = _interopRequireDefault(require("./cellTypes/CellFlags"));

var _CellText = _interopRequireDefault(require("./cellTypes/CellText"));

var _CellBool = _interopRequireDefault(require("./cellTypes/CellBool"));

var _CellLink = _interopRequireDefault(require("./cellTypes/CellLink"));

var _Array = require("../../utils/Array");

var _CwDataGrid = _interopRequireDefault(require("./CwDataGrid.scss"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var selectionModes = {
  SINGLE: 'single',
  MULTI: 'multi',
  BLOCK: 'block'
};
exports.selectionModes = selectionModes;

var CwDataGrid =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(CwDataGrid, _React$Component);

  function CwDataGrid(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CwDataGrid);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CwDataGrid).call(this, props));
    _this.state = {
      columnDefs: [],
      scrollLeft: 0,
      gridHeight: 0,
      isFocused: false,
      blockSelectionAnchorId: null,
      calculateHeight: _this.props.calculateHeight,
      calculateWidth: _this.props.calculateWidth,
      selectionMode: selectionModes.SINGLE,
      contextMenu: {
        show: false,
        x: 0,
        y: 0
      },
      dateDialog: {
        columnKey: '',
        initStartDate: null,
        initEndDate: null,
        show: false
      },
      invalidDate: false,
      errorMessage: ''
    };
    _this.handleCalcColumnWidths = _this.handleCalcColumnWidths.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleContextOptionClick = _this.handleContextOptionClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleHeaderScroll = _this.handleHeaderScroll.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleRowContextMenu = _this.handleRowContextMenu.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleScroll = _this.handleScroll.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleWindowBlur = _this.handleWindowBlur.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleWindowClick = _this.handleWindowClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleWindowKeyDown = _this.handleWindowKeyDown.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleWindowKeyUp = _this.handleWindowKeyUp.bind((0, _assertThisInitialized2.default)(_this));
    _this.reorderColumn = _this.reorderColumn.bind((0, _assertThisInitialized2.default)(_this));
    _this.resizeColumn = _this.resizeColumn.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderCell = _this.renderCell.bind((0, _assertThisInitialized2.default)(_this));
    _this.hideDateDialog = _this.hideDateDialog.bind((0, _assertThisInitialized2.default)(_this));
    _this.saveDateDialog = _this.saveDateDialog.bind((0, _assertThisInitialized2.default)(_this));
    _this.showDateDialog = _this.showDateDialog.bind((0, _assertThisInitialized2.default)(_this));
    _this.validateDateRange = _this.validateDateRange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(CwDataGrid, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('blur', this.handleWindowBlur);
      window.addEventListener('click', this.handleWindowClick);
      window.addEventListener('keydown', this.handleWindowKeyDown);
      window.addEventListener('keyup', this.handleWindowKeyUp);
      this.calcColumnWidths();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this; // remove height for toolbar / column headers / footer


      var gridHeight = this.props.height - 32; // adjust height

      if (this.state.gridHeight !== gridHeight) {
        this.setState({
          // eslint-disable-line react/no-did-update-set-state
          gridHeight: gridHeight
        });
      } // adjust width


      if (this.props.fluidColumns) {
        this.calcColumnWidths();
      } // adjust column filter items


      if (this.columnFilterItemsNeedUpdate()) {
        this.setState({
          columnDefs: this.state.columnDefs.map(function (columnDef) {
            var columnDefCopy = Object.assign({}, columnDef);

            var updatedColumnDef = _this2.props.columnDefs.filter(function (c) {
              return c.key === columnDef.key;
            });

            if (updatedColumnDef.length > 0) {
              columnDefCopy.filterItems = updatedColumnDef[0].filterItems;
            }

            return columnDefCopy;
          })
        });
      } // reset block selection anchor id if it no longer exists in data set


      if (this.state.blockSelectionAnchorId && this.props.data.findIndex(function (row) {
        return row.id === _this2.state.blockSelectionAnchorId;
      }) === -1) {
        this.setState({
          blockSelectionAnchorId: null
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('blur', this.handleWindowBlur);
      window.removeEventListener('click', this.handleWindowClick);
      window.removeEventListener('keydown', this.handleWindowKeyDown);
      window.removeEventListener('keyup', this.handleWindowKeyUp);
    }
  }, {
    key: "getCanvasWidth",
    value: function getCanvasWidth() {
      var _this3 = this;

      var returnWidth = 0;
      this.state.columnDefs.filter(function (col) {
        return !_this3.props.disabledColumns.includes(col.key);
      }).forEach(function (col) {
        returnWidth += col.width;
      });
      return returnWidth;
    }
  }, {
    key: "setColumnDefs",
    value: function setColumnDefs(columnDefs) {
      this.setState({
        columnDefs: columnDefs
      });
    }
  }, {
    key: "calcColumnWidths",
    value: function calcColumnWidths() {
      var _this4 = this;

      window.setTimeout(function () {
        _this4.handleCalcColumnWidths();
      }, 0);
    }
  }, {
    key: "columnFilterItemsNeedUpdate",
    value: function columnFilterItemsNeedUpdate() {
      var _this5 = this;

      var returnValue = false;
      this.state.columnDefs.forEach(function (col) {
        var propCol = _this5.props.columnDefs.filter(function (columnDef) {
          return columnDef.key === col.key;
        });

        if (propCol.length > 0 && JSON.stringify(propCol[0].filterItems) !== JSON.stringify(col.filterItems)) {
          returnValue = true;
        }

        return col;
      });
      return returnValue;
    }
  }, {
    key: "reorderColumn",
    value: function reorderColumn(source, target, rightSide) {
      var sourceIndex = null;
      var targetIndex = null; // look for source and target index

      this.state.columnDefs.forEach(function (col, i) {
        if (col.key === source) {
          sourceIndex = i;
        } else if (col.key === target) {
          targetIndex = i;
        }
      }); // adjust target index

      if (!rightSide && sourceIndex < targetIndex) {
        targetIndex -= 1;
      }

      if (rightSide && sourceIndex > targetIndex) {
        targetIndex += 1;
      } // set new columnDefs


      if (sourceIndex !== null && targetIndex !== null && sourceIndex !== targetIndex) {
        var newColumnDefs = this.state.columnDefs.slice();
        (0, _Array.arrayMoveItem)(newColumnDefs, sourceIndex, targetIndex);
        this.setState({
          columnDefs: newColumnDefs
        });
        this.props.onColumnReorder(newColumnDefs);
      }
    }
  }, {
    key: "resizeColumn",
    value: function resizeColumn(key, sizeDiff) {
      var newColumnDefs = this.state.columnDefs.map(function (col) {
        var returnValue = col;

        if (col.key === key) {
          // this is the column to resize, calc new size
          var newSize = col.width + sizeDiff;

          if (Object.prototype.hasOwnProperty.call(col, 'minWidth') && col.minWidth > newSize) {
            newSize = col.minWidth;
          }

          returnValue = Object.assign({}, col, {
            width: newSize
          });
        }

        return returnValue;
      });
      this.setState({
        columnDefs: newColumnDefs
      });
      this.props.onColumnResize(newColumnDefs);
    }
  }, {
    key: "handleCalcColumnWidths",
    value: function handleCalcColumnWidths() {
      var thisNode = (0, _reactDom.findDOMNode)(this);
      var filteredColumnDefs = this.props.columnDefs; // determine remaining width based on all column width values and space available

      var usedWidth = 0;
      filteredColumnDefs.forEach(function (col) {
        if (typeof col.width === 'number' && col.flexCol !== true) {
          usedWidth += col.width;
        }
      });
      var remainingWidth = thisNode.clientWidth - usedWidth - 22; // make sure width is greater or equal to min width

      var nullWidthCol = filteredColumnDefs.find(function (col) {
        return col.flexCol === true;
      });

      if (typeof nullWidthCol !== 'undefined') {
        if (Object.prototype.hasOwnProperty.call(nullWidthCol, 'minWidth') && remainingWidth < nullWidthCol.minWidth) {
          remainingWidth = nullWidthCol.minWidth;
        }
      } // set width value for the flexCol


      var newColumnDefs = filteredColumnDefs.map(function (col) {
        var newCol = Object.assign({}, col);

        if (newCol.flexCol === true) {
          newCol.width = remainingWidth;
        }

        return newCol;
      });

      if (JSON.stringify(this.state.columnDefs) !== JSON.stringify(newColumnDefs)) {
        this.setState({
          columnDefs: newColumnDefs
        });
      }
    }
  }, {
    key: "handleContextOptionClick",
    value: function handleContextOptionClick(option) {
      if (option.children.length === 0) {
        this.hideContextMenu();
      }

      this.props.onContextOptionClick(option);
    }
  }, {
    key: "handleHeaderScroll",
    value: function handleHeaderScroll(scrollLeft) {
      this.rowsViewport.scrollLeft = scrollLeft;
    }
  }, {
    key: "handleRowClick",
    value: function handleRowClick(rowId) {
      var _this6 = this;

      if (!this.props.allowMultiSelection) {
        this.props.setSelectedRow(rowId);
      } else {
        var rowIdIndex;
        var blockSelectionArray;
        var blockSelectionStartIndex;
        var blockSelectionEndIndex;
        var i;

        switch (this.state.selectionMode) {
          case selectionModes.SINGLE:
            this.props.setSelectedRow([rowId]);
            break;

          case selectionModes.MULTI:
            rowIdIndex = this.props.selectedRow.indexOf(rowId);

            if (rowIdIndex >= 0) {
              // remove selected row
              var valueToSet = this.props.selectedRow.slice();
              valueToSet.splice(rowIdIndex, 1);
              this.props.setSelectedRow(valueToSet);
            } else {
              // add selected row
              this.props.setSelectedRow([].concat((0, _toConsumableArray2.default)(this.props.selectedRow), [rowId]));
            }

            break;

          case selectionModes.BLOCK:
            if (!this.state.blockSelectionAnchorId) {
              this.setState({
                blockSelectionAnchorId: rowId
              });
              this.props.setSelectedRow([rowId]);
            } else {
              blockSelectionStartIndex = this.props.data.findIndex(function (row) {
                return row.id === _this6.state.blockSelectionAnchorId;
              });
              blockSelectionEndIndex = this.props.data.findIndex(function (row) {
                return row.id === rowId;
              });

              if (blockSelectionStartIndex >= 0 && blockSelectionEndIndex >= 0 && blockSelectionStartIndex !== blockSelectionEndIndex) {
                blockSelectionArray = [];

                if (blockSelectionEndIndex > blockSelectionStartIndex) {
                  // loop forward
                  for (i = blockSelectionStartIndex; i <= blockSelectionEndIndex; i += 1) {
                    blockSelectionArray.push(this.props.data[i].id);
                  }
                } else {
                  // loop backwards
                  for (i = blockSelectionStartIndex; i >= blockSelectionEndIndex; i -= 1) {
                    blockSelectionArray.push(this.props.data[i].id);
                  }
                }

                this.props.setSelectedRow(blockSelectionArray);
              }
            }

            break;

          default: // do nothing

        } // update block selection anchor id


        switch (this.state.selectionMode) {
          case selectionModes.SINGLE:
          case selectionModes.MULTI:
            if (this.state.blockSelectionAnchorId !== rowId) {
              this.setState({
                blockSelectionAnchorId: rowId
              });
            }

            break;

          default: // do nothing

        }
      }
    }
  }, {
    key: "handleRowContextMenu",
    value: function handleRowContextMenu(event, rowId) {
      // select row
      if (this.props.allowMultiSelection) {
        if (this.props.selectedRow === null || this.props.selectedRow.indexOf(rowId) < 0) {
          this.props.setSelectedRow([rowId]);
        }
      } else if (this.props.selectedRow !== rowId) {
        this.props.setSelectedRow(rowId);
      } // show context menu


      if (this.props.contextOptions.length) {
        event.preventDefault();
        this.showContextMenu(event.clientX, event.clientY);
      }
    }
  }, {
    key: "handleScroll",
    value: function handleScroll() {
      this.setState({
        scrollLeft: this.rowsViewport.scrollLeft
      });
    }
  }, {
    key: "handleWindowBlur",
    value: function handleWindowBlur() {
      // reset selection mode when window blurs because
      // we can't detect events outside of the window
      this.setState({
        selectionMode: selectionModes.SINGLE
      });
    }
  }, {
    key: "handleWindowClick",
    value: function handleWindowClick(event) {
      // focus grid
      var isFocused = this.grid.contains(event.target);

      if (this.state.isFocused !== isFocused) {
        this.setState({
          isFocused: isFocused
        });
      } // hide context menu


      var contextMenu = (0, _reactDom.findDOMNode)(this.contextMenu);

      if (contextMenu && !contextMenu.contains(event.target)) {
        this.hideContextMenu();
      }
    }
  }, {
    key: "handleWindowKeyDown",
    value: function handleWindowKeyDown(event) {
      var selectionMode = selectionModes.SINGLE;

      switch (event.key) {
        case 'Escape':
          this.hideContextMenu();
          break;

        case 'Control':
          selectionMode = selectionModes.MULTI;
          break;

        case 'Shift':
          selectionMode = selectionModes.BLOCK;
          break;

        case 'a':
        case 'A':
          // select all
          if (this.state.selectionMode === selectionModes.MULTI) {
            selectionMode = selectionModes.MULTI;

            if (this.state.isFocused) {
              this.props.setSelectedRow(this.props.data.map(function (row) {
                return row.id;
              }));
            }
          }

          break;

        default: // do nothing

      }

      if (this.state.selectionMode !== selectionMode) {
        this.setState({
          selectionMode: selectionMode
        });
      }
    }
  }, {
    key: "handleWindowKeyUp",
    value: function handleWindowKeyUp(event) {
      switch (event.key) {
        case 'Control':
          if (this.state.selectionMode === selectionModes.MULTI) {
            this.setState({
              selectionMode: selectionModes.SINGLE
            });
          }

          break;

        case 'Shift':
          if (this.state.selectionMode === selectionModes.BLOCK) {
            this.setState({
              selectionMode: selectionModes.SINGLE
            });
          }

          break;

        default: // do nothing

      }
    }
    /* CONTEXT MENU */

  }, {
    key: "hideContextMenu",
    value: function hideContextMenu() {
      if (this.state.contextMenu.show) {
        this.setState({
          contextMenu: _objectSpread({}, this.state.contextMenu, {
            show: false
          })
        });
      }
    }
  }, {
    key: "showContextMenu",
    value: function showContextMenu(x, y) {
      this.props.onContextMenuOpen();
      this.setState({
        contextMenu: {
          show: true,
          x: x,
          y: y
        }
      });
    }
    /* DATE DIALOG */

  }, {
    key: "hideDateDialog",
    value: function hideDateDialog() {
      this.setState({
        dateDialog: _objectSpread({}, this.state.dateDialog, {
          show: false
        }),
        invalidDate: false,
        errorMessage: ''
      });
    }
  }, {
    key: "saveDateDialog",
    value: function saveDateDialog(startDate, endDate) {
      if (this.props.shouldValidateDateRange) {
        this.validateDateRange(startDate, endDate);
      } else {
        this.props.onColumnFilterChange({
          key: this.state.dateDialog.columnKey
        }, {
          startDate: startDate,
          endDate: endDate
        });
        this.hideDateDialog();
      }
    }
  }, {
    key: "showDateDialog",
    value: function showDateDialog(column, filterValue) {
      var _this7 = this; // set initial date values before showing dialog


      this.setState({
        dateDialog: {
          columnKey: column.key,
          initStartDate: filterValue.startDate,
          initEndDate: filterValue.endDate,
          show: false
        }
      }, function () {
        // show the dialog after setting initial date values
        _this7.setState({
          dateDialog: _objectSpread({}, _this7.state.dateDialog, {
            show: true
          })
        });
      });
    }
  }, {
    key: "renderCell",
    value: function renderCell(row, col) {
      switch (col.cellType) {
        case 'custom':
          return _react.default.createElement(_CellCustom.default, {
            col: col,
            row: row
          });

        case 'boolFlags':
          return _react.default.createElement(_CellBoolFlags.default, {
            col: col,
            row: row,
            flags: this.props.boolFlags
          });

        case 'date':
          return _react.default.createElement(_CellDate.default, {
            col: col,
            row: row
          });

        case 'flags':
          return _react.default.createElement(_CellFlags.default, {
            col: col,
            row: row,
            flagIconsSrc: this.props.flagIconsSrc
          });

        case 'text':
          return _react.default.createElement(_CellText.default, {
            col: col,
            row: row
          });

        case 'boolStatus':
          return _react.default.createElement(_CellBool.default, {
            col: col,
            row: row,
            falseImage: this.props.cellBoolFalseImage,
            trueImage: this.props.cellBoolTrueImage
          });

        case 'link':
          return _react.default.createElement(_CellLink.default, {
            col: col,
            row: row
          });

        default:
          return null;
      }
    }
  }, {
    key: "validateDateRange",
    value: function validateDateRange(startDate, endDate) {
      var dateFormat = 'YYYY-MM-DD';
      var timeFormat = 'HH:mm:ssZ';
      var startTime = '';
      var endTime = '';

      if (_moment.default.isMoment(this.state.startDate)) {
        startDate = this.state.startDate.format(dateFormat);
      }

      if (_moment.default.isMoment(this.state.startTime)) {
        startTime = this.state.startTime.format(timeFormat);
      }

      if (_moment.default.isMoment(this.state.endDate)) {
        endDate = this.state.endDate.format(dateFormat);
      }

      if (_moment.default.isMoment(this.state.endTime)) {
        endTime = this.state.endTime.format(timeFormat);
      }

      if (startDate > endDate || startDate === endDate && startTime >= endTime) {
        this.setState({
          invalidDate: true,
          errorMessage: 'Please Enter a Valid Date Range'
        });
      } else {
        this.props.onColumnFilterChange({
          key: this.state.dateDialog.columnKey
        }, {
          startDate: startDate,
          endDate: endDate
        });
        this.hideDateDialog();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this8 = this;

      return _react.default.createElement("div", {
        "data-cwid": this.props.cwId,
        ref: function ref(c) {
          _this8.grid = c;
        },
        style: {
          position: 'relative'
        },
        className: (0, _classnames.default)(this.props.className, (0, _defineProperty2.default)({}, _CwDataGrid.default.useAltColors, this.props.useAltColors))
      }, this.state.contextMenu.show && this.props.contextOptions.length && _react.default.createElement(_CwContextMenu.default, {
        ref: function ref(c) {
          _this8.contextMenu = c;
        },
        cwId: "".concat(this.props.cwId, "_context"),
        options: this.props.contextOptions,
        x: this.state.contextMenu.x,
        y: this.state.contextMenu.y,
        onOptionClick: this.handleContextOptionClick,
        expandIcon: this.props.contextExpandIcon,
        scrollIconDown: this.props.contextScrollDownIcon,
        scrollIconUp: this.props.contextScrollUpIcon
      }), this.state.dateDialog.show === true && _react.default.createElement(_DateFilterDialog.default, {
        cwId: "".concat(this.props.cwId, "_date_filter_dialog"),
        datePickerIcon: this.props.datePickerIcon,
        disabled: this.props.disabledDateFields,
        errorMessage: this.state.errorMessage,
        initStartDate: this.state.dateDialog.initStartDate,
        initEndDate: this.state.dateDialog.initEndDate,
        invalid: this.state.invalidDate,
        onSaveClick: this.saveDateDialog,
        onCancelClick: this.hideDateDialog
      }), _react.default.createElement(_CwLoader.default, {
        loaderCnt: this.props.loaderCnt,
        style: {
          position: 'absolute',
          top: 0,
          width: '100%',
          height: this.props.height + 32,
          zIndex: 5
        }
      }), _react.default.createElement(_ColumnHeaderContainer.default, {
        cwId: this.props.cwId,
        columnDefs: this.state.columnDefs,
        clearFilterImage: this.props.clearFilterImage,
        disabledColumns: this.props.disabledColumns,
        filterValues: this.props.filterValues,
        onColumnFilterChange: this.props.onColumnFilterChange,
        onColumnComboBoxTextChange: this.props.onColumnComboBoxTextChange,
        onDateFilterClick: this.showDateDialog,
        hasFilterTypes: this.props.hasFilterTypes,
        onScroll: this.handleHeaderScroll,
        scrollLeft: this.state.scrollLeft,
        allowColumnReordering: this.props.allowColumnReordering,
        sortCol: this.props.sortCol,
        sortReverse: this.props.sortReverse,
        setSortCol: this.props.setSortCol,
        sortArrowImage: this.props.sortArrowImage,
        sortArrowImageReverse: this.props.sortArrowImageReverse,
        handleColumnReorder: this.reorderColumn,
        handleColumnResize: this.resizeColumn
      }), _react.default.createElement("div", {
        ref: function ref(c) {
          _this8.rowsViewport = c;
        },
        className: _CwDataGrid.default.rowsContainer,
        style: {
          overflowY: !this.props.data.length && 'hidden',
          height: this.state.calculateHeight ? this.state.gridHeight : 'inherit'
        },
        onScroll: this.handleScroll,
        "data-rowsviewport": true
      }, !this.props.data.length && _react.default.createElement("div", {
        className: _CwDataGrid.default.noResultsContainer,
        style: {
          left: this.state.scrollLeft
        }
      }, !this.props.noResultsText.length ? 'No Results' : this.props.noResultsText), _react.default.createElement("div", {
        className: _CwDataGrid.default.rowsCanvas,
        style: {
          width: this.state.calculateWidth ? this.getCanvasWidth() : 'inherit'
        }
      }, !this.props.data.length && "\xA0", this.props.data.map(function (row) {
        var rowClass = (0, _classnames.default)(_CwDataGrid.default.row, (0, _defineProperty2.default)({}, _CwDataGrid.default.active, Array.isArray(_this8.props.selectedRow) ? _this8.props.selectedRow.includes(row.id) : _this8.props.selectedRow === row.id));
        return _react.default.createElement("div", {
          "data-cwid": "".concat(_this8.props.cwId, "_row_").concat(row.id),
          key: row.id,
          className: rowClass,
          onClick: function onClick() {
            return _this8.handleRowClick(row.id);
          },
          onDoubleClick: function onDoubleClick() {
            return _this8.props.handleRowDoubleClick(row);
          },
          onContextMenu: function onContextMenu(event) {
            _this8.handleRowContextMenu(event, row.id);
          }
        }, _this8.state.columnDefs.filter(function (col) {
          return !_this8.props.disabledColumns.includes(col.key);
        }).map(function (col) {
          return _react.default.createElement("span", {
            key: col.key + row.id,
            "data-column-key": col.key
          }, _this8.renderCell(row, col));
        }));
      }))));
    }
  }]);
  return CwDataGrid;
}(_react.default.Component);

CwDataGrid.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes.default.string,

  /**
   * Image to display as false inside cell bool
   */
  cellBoolFalseImage: _propTypes.default.string,

  /**
   * Image to display as true inside cell bool
   */
  cellBoolTrueImage: _propTypes.default.string,

  /**
   * Array of column definitions, see notes at the top of this file
   */
  columnDefs: _propTypes.default.array.isRequired,

  /**
   * Icon to display in context menu for options that have chilren
   */
  contextExpandIcon: _propTypes.default.string,

  /**
   * Icon to display in context menu to scroll the menu down
   */
  contextScrollDownIcon: _propTypes.default.string,

  /**
   * Icon to display in context menu to scroll the menu up
   */
  contextScrollUpIcon: _propTypes.default.string,

  /**
   * Array of options for the right-click context menu for rows in the grid
   */
  contextOptions: _propTypes.default.array,

  /**
   * Icon to display in filter boxes to clear the filter value
   */
  clearFilterImage: _propTypes.default.string,

  /**
   * Icon to display in the date picker dialog for date filters
   */
  datePickerIcon: _propTypes.default.string,

  /**
   * Array of column keys to disable (not show)
   */
  disabledColumns: _propTypes.default.array,

  /**
   * Used to disable custom date entry in DateFilterDialog
   */
  disabledDateFields: _propTypes.default.bool,

  /**
   * Used to control if date is valid in DateFilterDialog
   */
  invalidDate: _propTypes.default.bool,

  /**
   * Used to display error message if date range is invalid in DateFilterDialog
   */
  errorMessage: _propTypes.default.string,

  /**
   * Object representing values for column filters, this object should have one
   * property per column key that exists in columnDefs, the value will depend on
   * what type of column is being used
   */
  filterValues: _propTypes.default.object,

  /**
   * Array of row data
   */
  data: _propTypes.default.array.isRequired,

  /**
   * Object specifying icons to use specifically for the CellFlags cell type
   */
  flagIconsSrc: _propTypes.default.object,

  /**
   * When set to true, the grid will recalculate column sizes when the size of it's container changes
   * the column set to "flexCol: true" will be dynamically sized so the grid fits the container
   * NOTE: setting this to true will break manual column resizing
   */
  fluidColumns: _propTypes.default.bool,

  /**
   * If set to true, users can reorder columns by dragging and dropping the column header
   */
  allowColumnReordering: _propTypes.default.bool,

  /**
   * If set to true, multiple rows in the grid can be selected, this will affect the type of selectedRow prop
   */
  allowMultiSelection: _propTypes.default.bool,

  /**
   * Set to true if at least one column has a filter type
   */
  hasFilterTypes: _propTypes.default.bool,

  /**
   * Height of the grid, in pixels
   */
  height: _propTypes.default.number,

  /**
   * If set to a value greater than 0, a loader is shown over the grid
   * User can not interact with the grid while this is shown
   */
  loaderCnt: _propTypes.default.number,

  /**
   * If multi select is disabled, this should be the column id
   * If multi select is enabled, this should be an array of column ids
   */
  selectedRow: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.array]),

  /**
   * If set to true, invalid date ranges will not be allowed
   */
  shouldValidateDateRange: _propTypes.default.bool,

  /**
   * Column key of current sort column
   */
  sortCol: _propTypes.default.string,

  /**
   * True if current sort is desc
   * False if current sort is asc
   */
  sortReverse: _propTypes.default.bool,

  /**
   * Image to use as the sort asc
   */
  sortArrowImage: _propTypes.default.string,

  /**
   * Image to use as the sort desc
   */
  sortArrowImageReverse: _propTypes.default.string,

  /**
   * If false, grid height is inherited
   */
  calculateHeight: _propTypes.default.bool,

  /**
   * If false, grid width is inherited
   */
  calculateWidth: _propTypes.default.bool,

  /**
   * The css class name to be appended to default classname
   */
  className: _propTypes.default.string,

  /**
   * Array of flags to use for the CellBoolFlags cell type
   */
  boolFlags: _propTypes.default.object,

  /**
   * Text to display when there are no results in the grid
   */
  noResultsText: _propTypes.default.string,

  /**
   * Used for displaying alternate grid colors
   */
  useAltColors: _propTypes.default.bool,

  /**
   * Callback fired when a row is double clicked
   */
  handleRowDoubleClick: _propTypes.default.func,

  /**
   * Callback fired when combo box text is changed in filters
   */
  onColumnComboBoxTextChange: _propTypes.default.func,

  /**
   * Callback fired when a column filter value has changed
   */
  onColumnFilterChange: _propTypes.default.func,

  /**
   * Callback fired when a user reorders a column
   */
  onColumnReorder: _propTypes.default.func,

  /**
   * Callback fired when a user resizes a column
   */
  onColumnResize: _propTypes.default.func,

  /**
   * Callback fired when user opens the context menu
   */
  onContextMenuOpen: _propTypes.default.func,

  /**
   * Callback fired when a user clicks a context menu option
   */
  onContextOptionClick: _propTypes.default.func,

  /**
   * Callback fired when user single clicks a row
   */
  setSelectedRow: _propTypes.default.func,

  /**
   * Callback fired when user clicks a column header to change sorting
   */
  setSortCol: _propTypes.default.func
};
CwDataGrid.defaultProps = {
  cwId: '',
  cellBoolFalseImage: '',
  cellBoolTrueImage: '',
  clearFilterImage: '',
  contextExpandIcon: '',
  contextScrollDownIcon: '',
  contextScrollUpIcon: '',
  contextOptions: [],
  datePickerIcon: '',
  disabledColumns: [],
  disabledDateFields: false,
  invalidDate: false,
  errorMessage: '',
  flagIconsSrc: {},
  filterValues: {},
  fluidColumns: false,
  allowColumnReordering: false,
  allowMultiSelection: false,
  hasFilterTypes: false,
  height: 0,
  loaderCnt: 0,
  selectedRow: '',
  shouldValidateDateRange: false,
  sortCol: '',
  sortReverse: false,
  sortArrowImage: '',
  sortArrowImageReverse: '',
  calculateHeight: true,
  calculateWidth: true,
  className: '',
  boolFlags: {},
  noResultsText: '',
  useAltColors: false,
  handleRowDoubleClick: function handleRowDoubleClick() {},
  onColumnComboBoxTextChange: function onColumnComboBoxTextChange() {},
  onColumnFilterChange: function onColumnFilterChange() {},
  onColumnReorder: function onColumnReorder() {},
  onColumnResize: function onColumnResize() {},
  onContextMenuOpen: function onContextMenuOpen() {},
  onContextOptionClick: function onContextOptionClick() {},
  setSelectedRow: function setSelectedRow() {},
  setSortCol: function setSortCol() {}
};
var _default = CwDataGrid;
exports.default = _default;